import React from 'react';
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";

interface SignInProps {
    signInMessage: string;
}

const SignIn: React.FC<SignInProps> = ({signInMessage }) => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    return (
        <button
            onClick={() => setDynamicStateObj({visiblePopup: 'signin'})}
            className="px-2.5 py-1 rounded-lg text-cyan-600 hover:text-cyan-500 bg-neutral-950 dark:bg-neutral-800 hover:bg-neutral-300 dark:hover:bg-neutral-700 bg-opacity-10 hover:bg-opacity-20">
            {signInMessage}
        </button>
    );
};

export default SignIn;